module.exports = __webpack_public_path__ + "static/img/sj_video_img.ca6295a7.jpg";